import { UploadOutlined } from '@ant-design/icons'
import type { UploadFile } from 'antd'
import { message, Upload } from 'antd'
import type { UploadChangeParam } from 'antd/es/upload/interface'
import type { FC } from 'react'
import { useCallback, useState } from 'react'

import type { IUploadFileModelProps } from './UploadFile.model'
import { STextWrapp, SUpload, SUploadWrapp } from './UploadFile.styled'

export const UploadFiles: FC<IUploadFileModelProps> = ({
  onChangeCallback,
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>([])

  const handleOnChangeFile = useCallback(
    (file: UploadChangeParam) => {
      setFileList(file.fileList)
      onChangeCallback(file.fileList)
    },
    [onChangeCallback],
  )

  const beforeUpload = useCallback((file: File) => {
    if (file.size > 5 * 1024 * 1024) {
      message.error('Размер файла не должен превышать 5 МБ')
      return Upload.LIST_IGNORE
    }
    return false
  }, [])

  return (
    <SUploadWrapp>
      <SUpload
        multiple
        beforeUpload={beforeUpload}
        onChange={handleOnChangeFile}
        fileList={fileList}>
        <STextWrapp>Выберите файлы</STextWrapp>
        <UploadOutlined />
      </SUpload>
    </SUploadWrapp>
  )
}
